// import { AnimateChildAst } from '@angular/animations/browser/src/dsl/animation_ast';

export class Tarea {
    public registroHint: string;

    constructor(
        public TareaId: number,
        public Tarea?: string,
        public Comentario?: string,
        public ReclEmail?: number,
        public ReclTelefonica?: number,
        public Fecha?: string,
        public Hora?: string,
        public FReclamacion?: string,
        public Author?: string,
        public Medico?: string,
        public ToolTipText?: string,
        public Icon?: string,
        public tipo?: number,
        public fechaRegistro?: string,
        public usuario?: string
    ) {}
}

export class TareaViewModel {
    tareaId: number;
    medicoId: number;
    medico: string;
    empresaId: number;
    empresaNombre: string;
    fecha: any;
    usuario: string;
    tarea: string;
    tipo: number;
    trabajadorName: string;
    trabajadorSurname: string;
    trabajadorId: number;
    iconSrc: string;
    hora: any;
    bloqueado: string;
}
export class TareasDateRangeCount {
    count: number;
    fechaType: string;
}
